/**
 * Cifras de la cabecera (GEN-PX-008): lista de { id, valor, etiqueta }.
 * Añadir una cifra después es pasar un elemento más; sin cifras no se pinta nada.
 */

export default function Cifras({ items = [], etiqueta = 'Cifras del día' }) {
  if (items.length === 0) return null
  return (
    <ul className="dk-cab__cifras" aria-label={etiqueta}>
      {items.map(({ id, valor, etiqueta }) => (
        <li key={id} className="dk-cab__cifra" data-cifra={id}>
          <b>{valor}</b>
          <span>{etiqueta}</span>
        </li>
      ))}
    </ul>
  )
}
